import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'components/ButtonWithIcon';
import { showListContent, hideListContent } from 'data/ListContent/actions';
import { resetCurrentLocation } from 'data/CurrentLocation/actions';
import './index.scss';
import { ReactComponent as IconLocation } from './icon-location.svg';

/*
 * Types definition
 */
const propTypes = {
    listContent: PropTypes.bool,
    onMagnifyingGlassClick: PropTypes.func,
    onMarkerClick: PropTypes.func,
};

const defaultProps = {
    listContent: false,
    onMagnifyingGlassClick: () => null,
    onMarkerClick: () => null,
};

/*
 * Component
 */
class ListNavigation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleMagnifyingGlassClick = this.handleMagnifyingGlassClick.bind(this);
        this.handleMarkerClick = this.handleMarkerClick.bind(this);
    }

    handleMagnifyingGlassClick() {
        const { onMagnifyingGlassClick } = this.props;
        onMagnifyingGlassClick();
    }

    handleMarkerClick() {
        const { onMarkerClick } = this.props;
        onMarkerClick();
    }

    render() {
        const { listContent } = this.props;

        return (
            <nav className="list-navigation">
                <ButtonWithIcon
                    callback={this.handleMagnifyingGlassClick}
                    active={listContent}
                />
                <ButtonWithIcon
                    callback={this.handleMarkerClick}
                    icon={IconLocation}
                    active={!listContent}
                />
            </nav>
        );
    }
}

ListNavigation.propTypes = propTypes;
ListNavigation.defaultProps = defaultProps;

const mapDispatchToProps = dispatch => ({
    onMagnifyingGlassClick: () => {
        dispatch(showListContent());
        dispatch(resetCurrentLocation());
    },
    onMarkerClick: () => {
        dispatch(hideListContent());
    },
});


const mapStateToProps = state => ({
    listContent: state.listContent,
});

export default connect(mapStateToProps, mapDispatchToProps)(ListNavigation);
